import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // For query params and navigation
import {
  getEmandateRecords,
  getEmandatesfromLeadID,
  updateEmandateRecords,
} from "../../Services/Allotment";
import { useSelector } from "react-redux";
import { dismissLoader, presentLoader } from "../../Services/loader"; // Loader utilities
import EMandateAllotmentHandlerPage from "./EMandateAllotmentHandlerPage";
import { use } from "react";
import actions from "../../Redux Store/actions";
import { useDispatch } from "react-redux";

const EMandateAllotmentRoute = () => {
  let loggedInUser = useSelector((state) => state.Auth.user); // Get logged-in user details from Redux
  const [isEMandateCompleted, setIsEMandateCompleted] = useState(false); // To handle whether the dashboard or allotment cards will be displayed
  const [mandateRegistrationData, setMandateRegistrationData] = useState([]);
  const [allotmentsPresent, setAllotmentsPresent] = useState(null);
  const [filterAllotments, setFilterAllotments] = useState([]); // Filtered allotments to show
  const [isLoading, setIsLoading] = useState(true); // Track if the data is still loading
  const [hasFetchedData, setHasFetchedData] = useState(false); // Flag to track whether the data has already been fetched
  const navigate = useNavigate(); // For navigation
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    // Redirect to login if user is not logged in
    dispatch(actions.activeMenu("emandateallotments"));
  }, [loggedInUser, navigate, dispatch]);

  useEffect(() => {
    // Only fetch data if not already fetched
    if (hasFetchedData) return; // Skip fetching if data is already fetched

    // Fetch the allotments based on logged-in user's lead ID
    const params = new URLSearchParams(location.search);
    console.log("params --->", params);
    // Extract all parameters and store them in an object
    const allParams = {};
    params.forEach((value, key) => {
      allParams[key] = value;
    });

    // Debug the extracted parameters
    console.log("Extracted Parameters:", allParams);
    const allotmentPaymentIdFromParams = params.get("allotmentPaymentId");
    const consumerIdFromParams = params.get("consumerId");
    const mandateRegistrationNumberFromParams = params.get("mandateRegistrationNumber");
    const isRegisteredFromParams = params.get("isRegistered");

    presentLoader();

    if (allotmentPaymentIdFromParams && consumerIdFromParams) {
      const fetchEMandatesData = async () => {
        const payload = {
          mandateId: mandateRegistrationNumberFromParams,
          isRegistered: isRegisteredFromParams,
          consumerId: consumerIdFromParams,
          emandateStatus:
            isRegisteredFromParams === "true" ? "Initiated" : "Pending",
          response: allParams,
        };

        try {
          // Update the mandate status in the database
          const updatedEmandateData = await updateEmandateRecords(
            allotmentPaymentIdFromParams,
            payload,
          );
          console.log("Updated EMandates Data: ", updatedEmandateData);

          // Fetch mandates from the database based on the updated allotmentPaymentId and consumerId
          const mandates = await getEmandateRecords([
            allotmentPaymentIdFromParams,
          ]);
          if (mandates.length > 0) {
            setIsEMandateCompleted(true);
            setMandateRegistrationData(mandates);
            setFilterAllotments(mandates); // Set the fetched mandates as the filtered allotments to show
          } else {
            console.log("No mandates found for this allotmentPaymentId");
            setIsEMandateCompleted(false);
          }
        } catch (error) {
          console.error("Error fetching mandates:", error);
        } finally {
          setIsLoading(false); // Data is fetched, stop loading
          dismissLoader(); // Dismiss loader after fetching data
          setHasFetchedData(true); // Set flag to true to avoid fetching again
        }
      };

      fetchEMandatesData();
    } else {
      const fetchAllotments = async () => {
        try {
          const fetchAllotmentPaymentIds = await getEmandatesfromLeadID(
            loggedInUser.leadId,
          );
          if (fetchAllotmentPaymentIds && fetchAllotmentPaymentIds.data) {
            const allotmentPaymentIds = fetchAllotmentPaymentIds.data.map(
              (item) => item.allotmentPaymentId,
            );

            // Fetch EMandate records for the allotment IDs
            const fetchedEmandates =
              await getEmandateRecords(allotmentPaymentIds);

            if (fetchedEmandates && fetchedEmandates.length > 0) {
              setFilterAllotments(fetchedEmandates);
              setAllotmentsPresent(true);
            } else {
              setAllotmentsPresent(false);
            }
          }
        } catch (error) {
          console.error("Error fetching allotments:", error);
        } finally {
          dismissLoader(); // Dismiss the loader after data is fetched
          setIsLoading(false); // Stop loading after fetching data
          setHasFetchedData(true); // Set flag to true to avoid fetching again
        }
      };
      fetchAllotments();
    }
  }, [loggedInUser.leadId, location.search, hasFetchedData]); // Only fetch if `hasFetchedData` is false

  // console.log("filterAllotments:", filterAllotments);
  // console.log("mandateRegistrationData:", mandateRegistrationData);

  return (
    <div>
      <EMandateAllotmentHandlerPage
        filterAllotmentsData={filterAllotments}
        mandateRegistrationData={mandateRegistrationData}
      />
    </div>
  );
};

export default EMandateAllotmentRoute;
